enum ClientPortalPage {
  DASHBOARD = "Dashboard",
  APPOINTMENTS = "Appointments",
  BRANCHES = "Branches",
  MEDICAL_RECORDS = "Medical Records",
  BILLING = "Billing",
  SETTINGS = "Settings",
  LAB = "Lab"
}

export default ClientPortalPage;
